import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import {
  federalDistrictSearchStatus,
  StatusTypes,
} from '@dashboard-experience/utils';
import SearchCollection from '../Search/SearchCollection';
import { hasAssessment } from '../utils';

interface Props {
  searches: Array<Record<string, any>>;
}

const FederalDistrictCivilSearch = ({
  searches,
}: Props): React.ReactElement => {
  const reportStatusType = hasAssessment(searches)
    ? StatusTypes.Assess
    : StatusTypes.Legacy;

  const status = federalDistrictSearchStatus(searches, reportStatusType);

  return (
    <SearchCollection
      type='civil'
      title={i18n.getStr(
        'components.criminalScreenings.federalDistrictCivilSearches',
      )}
      hideSuspended
      searches={searches}
      assessmentEnabled
      status={status}
    />
  );
};

export default FederalDistrictCivilSearch;
